import type { SemanaPublic } from '@app/shared';

import { api } from '../../../lib/api';

// ciclo-tareas: circuito planificar/ejecutar/cerrar.
export const semanaApi = {
  async actual(): Promise<SemanaPublic> {
    const { data } = await api.get<{ semana: SemanaPublic }>('/semanas/actual');
    return data.semana;
  },

  /** D-044: define o cambia el objetivo de la semana activa. */
  async definirObjetivo(objetivo: string): Promise<SemanaPublic> {
    const { data } = await api.patch<{ semana: SemanaPublic }>('/semanas/actual/objetivo', { objetivo });
    return data.semana;
  },

  async guardar(): Promise<SemanaPublic> {
    const { data } = await api.post<{ semana: SemanaPublic }>('/semanas/guardar');
    return data.semana;
  },

  async cerrar(): Promise<SemanaPublic> {
    const { data } = await api.post<{ semana: SemanaPublic }>('/semanas/cerrar');
    return data.semana;
  },
};
